import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('calling-orchestration-shared-library', {
  library: 'calling-orchestration-shared-library'
});